import { View } from "./View";

export interface IReportSectionProps {
  title: string;
  description: string;
  iconSource: string;
  targetUrl: string;
}

export const ReportSection = (props: IReportSectionProps) => {
  return <View {...props} />;
};
